import type { PropType } from 'virtual-vue';
import type { StepDirection, StepProps } from './step';

export const DEFAULT_STEP_DIRECTION: StepDirection = 'horizontal';
export const DEFAULT_STEP_ACTIVE = 0;
export const DEFAULT_STEP_FLOW = true;
export const DEFAULT_STEP_INDEX = 0;

/**
 * Step 组件的props
 * 基于方案设计文档生成
 */
export const stepProps = {
  /**
   * 步骤条方向
   * @default 'horizontal'
   */
  direction: {
    type: String as PropType<StepProps['direction']>,
    default: DEFAULT_STEP_DIRECTION,
  },
  /**
   * 当前激活步骤索引（从 0 开始），横向和竖向模式都支持
   * @default 0
   */
  active: {
    type: Number as PropType<StepProps['active']>,
    default: DEFAULT_STEP_ACTIVE,
  },
  /**
   * 流程是否连贯。连贯模式下，横向Step完成一步后默认数字icon变为绿色，连线也绿；否则默认数字icon和连线都是灰色。竖向Step暂不受该参数影响
   * @default true
   */
  flow: {
    type: Boolean as PropType<StepProps['flow']>,
    default: DEFAULT_STEP_FLOW,
  },
};

/**
 * StepItem 组件的props
 * StepItem 组件无 Props，组件内部通过遍历 vNode 节点获取当前 item 的 index
 */
export const stepItemProps = {
  index: {
    type: Number,
    default: DEFAULT_STEP_INDEX,
  },
  /**
   * 当前激活步骤索引（从 0 开始），横向和竖向模式都支持
   * @default 0
   */
  active: {
    type: Number,
    default: DEFAULT_STEP_ACTIVE,
  },
  /**
   * 流程是否连贯。连贯模式下，横向Step完成一步后默认数字icon变为绿色，连线也绿；否则默认数字icon和连线都是灰色。竖向Step暂不受该参数影响
   * @default true
   */
  flow: {
    type: Boolean,
    default: DEFAULT_STEP_FLOW,
  },
};

/**
 * StepItemIcon 组件的props
 */
export const stepItemIconProps = {
  /**
   * 是否激活
   * @default false
   */
  activated: {
    type: Boolean,
    default: false,
  },
  /**
   * 是否小图标
   * @default false
   */
  small: {
    type: Boolean,
    default: false,
  },
};

/**
 * StepItemIconLine 组件的props
 */
export const stepItemIconLineProps = {
  /**
   * 是否激活状态
   * @default false
   */
  activated: {
    type: Boolean,
    default: false,
  },
  /**
   * 是否虚线
   * @default false
   */
  dashed: {
    type: Boolean,
    default: false,
  },
  /**
   * 是否水平
   * @default true
   */
  horizontal: {
    type: Boolean,
    default: true,
  },
};

